import { createClient } from '@supabase/supabase-js';
import axios from 'axios';

let supabase = null;
let initializationPromise = null;

const initializeSupabase = async () => {
  if (supabase) return supabase;
  
  if (!initializationPromise) {
    initializationPromise = (async () => {
      try {
        console.log('Initialisation de Supabase...');
        const response = await axios.get('/api/config');
        const { supabaseUrl, supabaseKey } = response.data;

        console.log('Configuration Supabase reçue:', {
          hasUrl: !!supabaseUrl,
          hasKey: !!supabaseKey,
          urlLength: supabaseUrl?.length,
          keyLength: supabaseKey?.length
        });

        if (!supabaseUrl || !supabaseKey) {
          throw new Error('Les variables d\'environnement Supabase sont manquantes');
        }

        supabase = createClient(supabaseUrl, supabaseKey, {
          auth: {
            autoRefreshToken: true,
            persistSession: true,
            detectSessionInUrl: true
          }
        });

        console.log('Client Supabase créé avec succès');
        return supabase;
      } catch (error) {
        console.error('Erreur lors de l\'initialisation de Supabase:', error);
        throw error;
      }
    })();
  }

  return initializationPromise;
};

// Initialiser Supabase immédiatement
initializeSupabase();

export { supabase, initializeSupabase }; 